// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//     employerJobList : [],
//     error: null,
//     loading: false
// }

// const employerJobSlice = createSlice({
//     name: "employerJobs",
//     initialState,
//     reducers: {
//         setEmployerJobList : (state, action)=>{
//             state.employerJobList = action.payload
//             state.error = null
//             state.loading = false
//         },
//         addNewEmployerJob : (state, action)=>{
//             state.employerJobList.push(action.payload)
//         },
//         removeAnEmployerJob : (state, action)=>{
//             state.employerJobList = state.employerJobList.filter(eachEmployerJob=>eachEmployerJob._id !== action.payload._id)
//         },
//         updateAnEmployerJob: (state, action) => {
//             state.employerJobList = state.employerJobList.map(
//                 eachEmployerJob => eachEmployerJob._id === action.payload._id ? action.payload : eachEmployerJob
//             );
//         }
//     }
// })

// export const { setEmployerJobList, addNewEmployerJob, removeAnEmployerJob, updateAnEmployerJob } = employerJobSlice.actions

// export default employerJobSlice.reducer





import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  employerJobList: [],
  error: null,
  loading: false,
};

export const fetchAvailableJobs = createAsyncThunk(
  "employerJobs/fetchAvailableJobs",
  async (employerId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}jobrecruiter/available-jobs/${employerId}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("jobEmployerToken")}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchJobSeekerDetails = createAsyncThunk(
  "employerJobs/fetchJobSeekerDetails",
  async ({ employerId, jobId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}jobrecruiter/job/${jobId}/details/${employerId}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("jobEmployerToken")}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const employerJobSlice = createSlice({
  name: "employerJobs",
  initialState,
  reducers: {
    setEmployerJobList: (state, action) => {
      state.employerJobList = action.payload;
      state.error = null;
      state.loading = false;
    },
    addNewEmployerJob: (state, action) => {
      state.employerJobList.push(action.payload);
    },
    removeAnEmployerJob: (state, action) => {
      state.employerJobList = state.employerJobList.filter(
        (eachEmployerJob) => eachEmployerJob._id !== action.payload._id
      );
    },
    updateAnEmployerJob: (state, action) => {
      state.employerJobList = state.employerJobList.map((eachEmployerJob) =>
        eachEmployerJob._id === action.payload._id ? action.payload : eachEmployerJob
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableJobs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAvailableJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.employerJobList = action.payload;
      })
      .addCase(fetchAvailableJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchJobSeekerDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJobSeekerDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.employerJobList = state.employerJobList.map((job) =>
          job._id === action.payload.jobId ? { ...job, jobSeekerDetails: action.payload } : job
        );
      })
      .addCase(fetchJobSeekerDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setEmployerJobList,
  addNewEmployerJob,
  removeAnEmployerJob,
  updateAnEmployerJob,
} = employerJobSlice.actions;
export default employerJobSlice.reducer;